import { COLOR } from "../config.ts";

/** A pooled, floating bonus pickup that restores a lost life on touch. */
export class Heart {
  x = 0;
  y = 0;
  px = 0;
  py = 0;
  vx = 0;
  vy = 0;
  radius = 16;
  life = 0;
  color = COLOR.heart;
  /** Random phase so pooled hearts don't all bob in lockstep. */
  seed = 0;

  reset(x: number, y: number, vx: number, vy: number, radius: number, life: number, seed: number): void {
    this.x = this.px = x;
    this.y = this.py = y;
    this.vx = vx;
    this.vy = vy;
    this.radius = radius;
    this.life = life;
    this.color = COLOR.heart;
    this.seed = seed;
  }
}
